/** Default shape for the ticket editor form bag (matches server-spec). */
export const EMPTY_TICKET = Object.freeze({
  title: '',
  description: '',
  status: null,
  priority: null,
  category: null,
  assignees: [],
  dueDate: null,
  private: false,
  archivedAt: null,
  deletedAt: null,
  tasks: [],
  history: [],
  linkedEntities: [],
  attachments: [],
})

/** Client-only list row display mode for account vs group management. */
export const TICKET_LIST_MODE = Object.freeze({
  ACCOUNT: 'account',
  GROUP: 'group',
})

export const TICKET_LIST_MODES = Object.values(TICKET_LIST_MODE)

/** Presentation modes for the management list card. */
export const TICKET_VIEW_MODE = Object.freeze({
  LIST: 'list',
  KANBAN: 'kanban',
  WEEK: 'week',
  MONTH: 'month',
})

export const TICKET_VIEW_MODES = Object.values(TICKET_VIEW_MODE)

/** Max chips rendered per day cell before “+N more”. */
export const TICKET_CALENDAR_MONTH_DAY_CAP = 3
export const TICKET_CALENDAR_WEEK_DAY_CAP = 6

/** Supported locales for ticket group settings. */
export const TICKET_GROUP_LOCALES = Object.freeze(['fi', 'en', 'sv'])
export const DEFAULT_TICKET_GROUP_LOCALE = 'fi'

/** Tracking-page recent-events feed window. */
export const TRACKING_RECENT_EVENTS_DAYS = 7
export const TRACKING_RECENT_EVENTS_MAX = 25

/** Default created-at window preset on the tracking period picker. */
export const TRACKING_PERIOD_DEFAULT = '90d'

/** Preset id → backward window in days from today. `all` = no created-at filter. */
export const TRACKING_PERIOD_PRESETS = Object.freeze({
  '7d': 7,
  '30d': 30,
  '90d': 90,
  all: null,
})

/**
 * Default filter bag for management + tracking pages. Keys mirror the filter
 * cards; `null` for scalar pickers, `[]` for multi-search pickers, `''` for dates.
 */
export const TICKET_FILTER_DEFAULTS = Object.freeze({
  search: '',
  status: null,
  priority: null,
  assignee: [],
  category: null,
  property: [],
  tenant: [],
  completionStatus: null,
  dueDateFrom: '',
  dueDateTo: '',
  createdAtFrom: '',
  createdAtTo: '',
})
